export interface Salary_Person_Interface {
    id: number,
    year: number,
    person_id: number,
    payeh: number,
    shift: number,
    tajrobeh: number,
    kpi: number,
    ayabZohab:number,
}


export function Empty_Salary_Person_Interface(): Salary_Person_Interface {
    return {
        id: 0,
        year: 0,
        person_id: 0,
        payeh: 0,
        shift: 0,
        tajrobeh: 0,
        kpi: 0,
        ayabZohab: 0,
    }
}
